define('ANSI/UIComponents/Tabsets',[
    'jquery',
    'StickyBits',
    'slick',
    'eventManager',
    'ANSI/Utility/SitecoreUtils',
    'ANSI/Utility/Dimensions'
], function ($, stickybits, slick, eventManager, sitecoreUtils, dimensions) {
    'use-strict';

    var tabSticky = function tabSticky() {
        var tabHorizontal = document.querySelector(
            '.page-wrapper .horizontal-tab-set'
        );
        var tabSection = tabHorizontal.querySelector('.nav-tabs-wrapper-outer');
        if ( dimensions.width > 767 ) {
            stickybits(tabSection, { stickyBitStickyOffset: 140 });
        } else {
            stickybits(tabSection, { stickyBitStickyOffset: 50 });
        }
    };
    var tabMobileSlider = function tabSlider() {
        var tab = $('.page-wrapper .score-tab')
            .not('.score-tab.horizontal-tab-set')
            .not('.score-tab.ans-overview-tab-set')
            .not('.score-tab.ans-overview-tab-set .score-tab')
            .not('.ansi-home-page .score-tab')
            .not('.news-events-slider.tab .score-tab');

        var tabContent = $(tab).find('.tab-content');
        var navTabs = $(tab).find('.nav-tabs');
        var settings = {
            draggable: true,
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            accessibility: true,
            centerMode: false,
            arrows: false,
            variableWidth: true,
            touchThreshold: 10,
            mobileFirst: true,
            asNavFor: tabContent,
            responsive: [
                {
                    breakpoint: 600,
                    settings: { slidesToShow: 3 }
                },
                {
                    breakpoint: 767,
                    settings: { slidesToShow: 4 }
                }
            ]
        };
        var contentSetting = {
            draggable: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            accessibility: true,
            centerMode: false,
            arrows: false,
            variableWidth: false,
            touchThreshold: 10,
            asNavFor: navTabs
        };

        if ( dimensions.width < 601 ) {
            $(tab).addClass('slider');
            navTabs.slick(settings);
            tabContent.slick(contentSetting);
        }
    };

    if ( !sitecoreUtils.prototype.isEditing() ) {
        eventManager.subscribe('ModulesLoadedEvent', function () {
            if ( document.querySelector('.horizontal-tab-set') ) {
                Promise.resolve().then(tabSticky);
            }
            if ( document.querySelector('.page-wrapper .score-tab') ) {
                Promise.resolve().then(tabMobileSlider);
            }
        });
    }
});

